import { render, staticRenderFns } from "./PCOverviewV2.vue?vue&type=template&id=bd2438f8&scoped=true"
import script from "./PCOverviewV2.vue?vue&type=script&setup=true&lang=js"
export * from "./PCOverviewV2.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PCOverviewV2.vue?vue&type=style&index=0&id=bd2438f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2438f8",
  null
  
)

export default component.exports